import { styled } from "linaria/react";
import { TDirection } from "@lib/utils";

export const SentimentContainer = styled.div`
  width: 25px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SentimentScore = styled.div`
  padding: 6px;
  background: #fff;
  color: #000;
  font-size: 16px;
`;

// `listening` marks an audio stream the user has actively subscribed to, so the
// CTA reads as engaged while it is holding the stream open.
export const AudioWrap = styled.button<{ listening?: boolean }>`
  background: ${(props) =>
    props.listening
      ? "var(--el-color-danger, #dc3545)"
      : "var(--el-color-success, #28a745)"};
  height: 30px;
  border-radius: var(--el-border-radius-round, 15px);
  display: flex;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  color: var(--el-color-white, #ffffff);
  font-weight: var(--el-font-weight-primary, bold);
  padding: 0 10px;
  cursor: pointer;
  border: none;

  &:focus-visible {
    outline: 2px solid var(--el-color-primary, #186dde);
    outline-offset: 2px;
  }
`;

export const UploadWrap = styled.div`
  background: #eee;
  padding: 8px;
  margin-right: 15px;
`;

export const KeywordsContainer = styled.div`
  width: 250px;
  height: 100%;
  overflow: scroll;
  text-align: -webkit-center;
`;

export const Keyword = styled.div<{ level: number }>`
  width: 80%;
  height: 30px;
  border-radius: 15px;
  background: ${(props) => (props.level === 1 ? "#f8d7da" : props.level === 2 ? "#fff3cd" : "#d1ecf1")};
  margin: 0 0 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
`;

export const KeywordTimestamp = styled.div`
  display: inline;
  font-size: 8px;
  right: 10px;
  position: absolute;
  bottom: 8px;
`;

export const TranscribeWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: 10px;
  background: #fff;
`;

export const TranscribeWrapContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  max-height: 100%;
  flex-grow: 1;
`;

export const TranscribeContainer = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  flex: 1;
  padding: 8px;
  padding-bottom: calc(8px + var(--el-font-size-base, 14px) * 1.5);
  > div {
    width: 100%;
  }
`;

export const TranscribeNote = styled.div<{ emphasized?: boolean }>`
  padding: 5px;
  font-size: 12px;
  font-weight: 500;
  font-style: ${(props) => (props.emphasized ? "italic" : "normal")};
  margin-bottom: ${(props) => (props.emphasized ? "0px" : "10px")};
`;

export const TranscribeTimestamp = styled.div<{isAfterIdentity?: boolean;}>`
  font-size: 10px;
  margin-top: ${(props) => (props.isAfterIdentity ? "0px" : "10px")};
  margin-bottom: 5px;
  margin-left: -10px;

  &.transcript-text-timestamp + .transcript-text-wrap {
    > span {
      padding-left: 10px;
    }
  }
`;

export const TranscribeTextWrap = styled.span`
  &.transcript-text-wrap + .transcript-text-wrap {
    > span {
      padding-left: 0;
    }
  }

  &.transcript-text-wrap:has(+ .transcript-text-timestamp),
  &.transcript-text-wrap:has(+ .transcript-text-header),
  &:not(:has(+ .transcript-text-wrap)) {
    > span {
      padding-right: 10px;
    }
  }
`;

export const TranscribeText = styled.span<{
  direction: "outbound" | "inbound";
  emphasized?: boolean;
}>`
  white-space: pre-wrap;
  width: 95%;
  align-self: flex-start;
  padding-left: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
  margin-bottom:5px;
  margin-top:10px;
  color: ${(props) =>
    props.direction === "outbound"
      ? "var(--el-text-color-secondary, #909399)"
      : "var(--el-text-color-primary, #303133)"};
  font-style: ${(props) => (props.emphasized ? "italic" : "normal")};
  &.transcript-item strong::first-letter {
    text-transform: uppercase;
  }

  &.transcript-interim .transcript-active-word {
    text-decoration: underline;
    text-decoration-style: dotted;
    text-underline-offset: 2px;
  }

  // &.highlight {
  //   background-color: #d6d8d9;
  // }
  // .transcript-speaker-0 {
  //   color: ${(props) => (props.direction !== "outbound" ? "#000" : "#b7b7b7")};
  // }
  // .transcript-speaker-1 {
  //   color: #0acc95;
  // }
  // .transcript-speaker-2 {
  //   color: #ffc107;
  // }
  // .transcript-speaker-3 {
  //   color: #ffcecb;
  // }
`;

export const CaptionFade = styled.span`
  animation: caption-fade-in 0.25s ease-out both;

  @keyframes caption-fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const TranscribeTextHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  margin-left:-10px;

  &.transcript-text-header + .transcript-text-wrap {
    > span {
      padding-left: 10px;
    }
  }
`;

export const TranscribeTextIdentity = styled.span`
  font-size: 13px;
  font-weight: bold;
  white-space: nowrap;
`;

export const TranslateWrap = styled.div``;
export const TranslatedText = styled.div`
  background: white;
  padding: 0 8px;
  font-size: 12px;
`;
